<template>
  <div>
    <GNavBar></GNavBar>
    <h1 class="mt-5 pt-5">CourseDev</h1>
    <hr />
    <b-row align-h="center">
      <b-col md="12">
        <transition name="component-fade" mode="out-in">
          <keep-alive>
            <component
              :is="currentDisplayComp"
            ></component> </keep-alive></transition
      ></b-col>
    </b-row>
  </div>
</template>

<script>
  // @ is an alias to /src
  import GProject from '@/components/GProject.vue'
  import GProjectDetails from '@/components/GProjectDetails.vue'
  import GNavBar from '@/components/GNavBar.vue'

  export default {
    name: 'ProjectPage',
    // TODO: handle errors; refactor api calls; use skeleton
    async created() {
      this.$store.commit('updateLoadingStatus', true)
      if (
        this.currentUser.program === 'OFDIT' ||
        this.currentUser.is_grizzly_admin
      ) {
        await this.$store.dispatch('getProjects')
        await this.$store.dispatch('getComments')
        await this.$store.dispatch('getContracts')
      } else {
        await this.$store.dispatch('getProjectsByProgram', {
          program: this.currentUser.program_id,
        })
        await this.$store.dispatch('getCommentsByProgram', {
          program: this.currentUser.program_id,
        })
        await this.$store.dispatch('getContractsByProgram', {
          program: this.currentUser.program_id,
        })
      }
      this.$store.dispatch('getOptions')
      this.$store.dispatch('getSemesters')
      this.$store.commit('updateLoadingStatus', false)
      this.pollData()
    },
    beforeDestroy() {
      clearInterval(this.polling)
    },
    data() {
      return {
        polling: null,
      }
    },
    computed: {
      currentDisplayComp() {
        return this.$store.state.courseDev.ui.projectDisplayComp
      },
      isOfdit() {
        return this.$store.getters.isOfdit
      },
      currentUser() {
        return this.$store.getters.currentUser
      },
    },
    components: {
      GProject,
      GProjectDetails,
      GNavBar,
    },
    methods: {
      hideDetails() {
        this.$store.commit('hideDetails')
      },
      loadDetails() {
        this.showDetails = true
      },
      pollData() {
        this.polling = setInterval(() => {
          if (this.isOfdit || this.currentUser.is_grizzly_admin) {
            this.$store.dispatch('getComments')
            this.$store.dispatch('getProjects')
          } else {
            this.$store.dispatch('getProjectsByProgram', {
              program: this.currentUser.program_id,
            })
            this.$store.dispatch('getCommentsByProgram', {
              program: this.currentUser.program_id,
            })
          }
        }, 120000)
      },
    },
  }
</script>
<style scoped>
  .hideDetails {
    display: none;
  }

  .showDetails {
    display: block;
    width: 100%;
  }

  .component-fade-enter-active,
  .component-fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .component-fade-enter,
  .component-fade-leave-to {
    opacity: 0;
  }
</style>
